import React from 'react';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import {
  CONFIRM_BG,
  CONFIRM_DESCRIPTION,
  CONFIRM_TITLE,
  CONFIRM_VARIANTS,
  CONFIRM_Z_INDEX,
} from './confirmConfig';

/**
 * Layout: acento izquierdo + ícono + título, descripción, acciones a la derecha.
 */
export default function ConfirmDialogView({
  open,
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'danger',
  onConfirm,
  onCancel,
}) {
  const theme = CONFIRM_VARIANTS[variant] || CONFIRM_VARIANTS.danger;
  const { accent, iconBg, iconColor, confirmBg, confirmBgHover, Icon } = theme;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth={false}
      sx={{ zIndex: CONFIRM_Z_INDEX }}
      PaperProps={{
        sx: {
          m: 2,
          width: '100%',
          maxWidth: 440,
          bgcolor: CONFIRM_BG,
          borderRadius: '10px',
          border: 'none',
          borderLeft: `3px solid ${accent}`,
          boxShadow: '0 16px 40px rgba(0,0,0,0.45)',
          overflow: 'hidden',
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            bgcolor: 'rgba(0,0,0,0.55)',
          },
        },
      }}
    >
      <DialogContent sx={{ p: 3, '&.MuiDialogContent-root': { pt: 3 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 28,
              height: 28,
              flexShrink: 0,
              borderRadius: '50%',
              bgcolor: iconBg,
            }}
          >
            <Icon sx={{ fontSize: 18, color: iconColor }} />
          </Box>
          <Typography
            component="h2"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600,
              fontSize: 16,
              lineHeight: '20px',
              color: CONFIRM_TITLE,
            }}
          >
            {title}
          </Typography>
        </Box>

        {description ? (
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: 14,
              lineHeight: '20px',
              color: CONFIRM_DESCRIPTION,
              mb: 3,
            }}
          >
            {description}
          </Typography>
        ) : (
          <Box sx={{ mb: 3 }} />
        )}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.25 }}>
          <Button
            onClick={onCancel}
            sx={{
              minWidth: 100,
              px: 2,
              py: 1,
              borderRadius: '8px',
              textTransform: 'none',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              fontSize: 14,
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.28)',
              bgcolor: 'transparent',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.06)',
                borderColor: 'rgba(255,255,255,0.4)',
              },
            }}
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            autoFocus
            sx={{
              minWidth: 100,
              px: 2,
              py: 1,
              borderRadius: '8px',
              textTransform: 'none',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              fontSize: 14,
              color: '#fff',
              bgcolor: confirmBg,
              '&:hover': { bgcolor: confirmBgHover },
            }}
          >
            {confirmLabel}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
